import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-03e45ae2")

_pushScopeId("data-v-03e45ae2")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("目录")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("菜单")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("按钮")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("禁用")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("显示")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("隐藏")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("普通菜单")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("AI菜单")
const _hoisted_12 = { class: "dialog-footer" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("确认")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_col = _resolveComponent("el-col")
  const _component_cSelectTree = _resolveComponent("cSelectTree")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_input = _resolveComponent("el-input")
  const _component_IconPicker = _resolveComponent("IconPicker")
  const _component_el_input_number = _resolveComponent("el-input-number")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_el_dialog, {
      width: "800px",
      title: `${_ctx.title}菜单(按钮)`,
      modelValue: _ctx.isDialog,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.isDialog = $event)),
      "close-on-click-modal": false,
      onClose: _ctx.handleCloseDialog
    }, {
      footer: _withId(() => [
        _createVNode("span", _hoisted_12, [
          _createVNode(_component_el_button, { onClick: _ctx.handleCloseDialog }, {
            default: _withId(() => [
              _hoisted_13
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.submitData
          }, {
            default: _withId(() => [
              _hoisted_14
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withId(() => [
        _createVNode(_component_el_form, {
          model: _ctx.formData,
          rules: _ctx.rules,
          "label-width": "140px",
          ref: "formRef"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_row, null, {
              default: _withId(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, {
                      label: '类型',
                      prop: "type"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_radio_group, {
                          modelValue: _ctx.formData.type,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.type = $event))
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_radio, { label: 0 }, {
                              default: _withId(() => [
                                _hoisted_1
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_radio, { label: 1 }, {
                              default: _withId(() => [
                                _hoisted_2
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_radio, { label: 2 }, {
                              default: _withId(() => [
                                _hoisted_3
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, {
                      label: '所属模块名称',
                      prop: "parentTag"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_cSelectTree, {
                          modelValue: _ctx.formData.parentTag,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.parentTag = $event)),
                          valueName: 'tag',
                          defaultProps: {
                  children: 'children',
                  label: 'menuName'
                },
                          options: _ctx.options
                        }, null, 8, ["modelValue", "options"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, null, {
              default: _withId(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, {
                      label: '菜单/按钮名称：',
                      prop: "menuName"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.menuName,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.menuName = $event)),
                          placeholder: '请输入'
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, {
                      label: '唯一标识：',
                      prop: "tag"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          disabled: _ctx.isDisable,
                          modelValue: _ctx.formData.tag,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.tag = $event)),
                          maxlength: 128,
                          minlength: 2,
                          placeholder: '请输入'
                        }, null, 8, ["disabled", "modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, null, {
              default: _withId(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, {
                          label: '前端路由地址：',
                          prop: "path"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.path,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formData.path = $event)),
                              placeholder: '请输入'
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, {
                          label: '组件路径：',
                          prop: "component"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.component,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formData.component = $event)),
                              placeholder: '请输入'
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, null, {
              default: _withId(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, {
                      label: '图标',
                      prop: "icon"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_IconPicker, {
                          modelValue: _ctx.formData.icon,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formData.icon = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, {
                      label: '后端地址',
                      prop: "apiAddress"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.formData.apiAddress,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.formData.apiAddress = $event)),
                          placeholder: '请输入'
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, null, {
              default: _withId(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, {
                      label: '排序地址',
                      prop: "sort"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input_number, {
                          modelValue: _ctx.formData.sort,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.formData.sort = $event)),
                          min: 0,
                          max: 10000,
                          placeholder: '请输入'
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, {
                      label: '状态',
                      prop: "enabled"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_radio_group, {
                          modelValue: _ctx.formData.enabled,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.formData.enabled = $event))
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_radio, { label: 1 }, {
                              default: _withId(() => [
                                _hoisted_4
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_radio, { label: 0 }, {
                              default: _withId(() => [
                                _hoisted_5
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, {
                      label: '是否显示',
                      prop: "display"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_radio_group, {
                          modelValue: _ctx.formData.display,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.formData.display = $event))
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_radio, { label: 1 }, {
                              default: _withId(() => [
                                _hoisted_6
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_radio, { label: 0 }, {
                              default: _withId(() => [
                                _hoisted_7
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_ctx.formData.type === 1)
                  ? (_openBlock(), _createBlock(_component_el_col, {
                      key: 0,
                      span: 12
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, {
                          label: '快捷菜单',
                          prop: "shortcutMenu"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_radio_group, {
                              modelValue: _ctx.formData.shortcutMenu,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.formData.shortcutMenu = $event))
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_radio, { label: 1 }, {
                                  default: _withId(() => [
                                    _hoisted_8
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_radio, { label: 0 }, {
                                  default: _withId(() => [
                                    _hoisted_9
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            (_ctx.formData.shortcutMenu === 1)
                              ? (_openBlock(), _createBlock(_component_el_input_number, {
                                  key: 0,
                                  modelValue: _ctx.formData.shortcutMenuSort,
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.formData.shortcutMenuSort = $event)),
                                  min: 0,
                                  max: 99,
                                  placeholder: '请输入',
                                  size: "small",
                                  class: "in-mini"
                                }, null, 8, ["modelValue"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.formData.type === 1)
                  ? (_openBlock(), _createBlock(_component_el_col, {
                      key: 1,
                      span: 12
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, {
                          label: '菜单类型',
                          prop: "menuType"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_radio_group, {
                              modelValue: _ctx.formData.menuType,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.formData.menuType = $event))
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_radio, { label: 1 }, {
                                  default: _withId(() => [
                                    _hoisted_10
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_radio, { label: 2 }, {
                                  default: _withId(() => [
                                    _hoisted_11
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["title", "modelValue", "onClose"])
  ]))
})